import {
  GO_TO_INDEX,
  GO_TO_NEW_FORM,
  GO_TO_UPDATE_FORM,
  GO_TO_SHOW,
  GO_TO_DELETE,
  GO_BACK,
  MARK_ASSET_FOR_ASSESSMENT,
  MARK_LIABILITY_FOR_ASSESSMENT,
  MARK_RISK_PRODUCT_FOR_ASSESSMENT,
  SUBMIT_FORM,
  DELETE_ASSESSMENT,
  LOADING
} from './actions'

export const VIEWS = {
  INDEX: 'index',
  CREATE: 'create',
  UPDATE: 'update',
  SHOW: 'show',
  DELETE: 'delete'
}

export const ASSESSMENT_TYPE = {
  LIFE_COVER: 'lifeCover',
  DISABILITY_COVER: 'disabilityCover',
  INCOME_PROTECTION: 'incomeProtection'
}

export const FORM_ACTIONS = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE'
}

export const ASIDE_VIEWS = {
  ASSETS: 'ASSETS',
  LIABILITIES: 'LIABILITIES',
  RISK_PRODUCTS: 'RISK_PRODUCTS',
  ESTATE_DUTY: "ESTATE_DUTY",
  DEPENDENTS: "DEPENDENTS",
}

const ASSESSMENT_TITLES = {
  [ASSESSMENT_TYPE.LIFE_COVER]: 'Life cover assessment',
  [ASSESSMENT_TYPE.DISABILITY_COVER]: 'Disability cover assessment',
  [ASSESSMENT_TYPE.INCOME_PROTECTION]: 'Income protection assessment'
}

export const ASSESSMENT_TYPE_NESTED_ATTRIBUTE_MAP = {
  [ASSESSMENT_TYPE.LIFE_COVER]: 'life_cover_assessment_attributes',
  [ASSESSMENT_TYPE.DISABILITY_COVER]: 'disability_cover_assessment_attributes',
  [ASSESSMENT_TYPE.INCOME_PROTECTION]: 'income_protection_assessment_attributes'
}

export default function reducer(state, { type, payload }) {
  switch (type) {
    case GO_TO_INDEX:
      return {
        ...state,
        assessmentType: null,
        title: 'Risk Assessments',
        view: VIEWS.INDEX,
        cameFrom: state.view
      }
    case GO_TO_NEW_FORM:
      return {
        ...state,
        title: ASSESSMENT_TITLES[payload.assessmentType],
        formAction: FORM_ACTIONS.CREATE,
        assessmentType: payload.assessmentType,
        view: VIEWS.CREATE,
        cameFrom: state.view
      }
    case GO_TO_SHOW:
      return {
        ...state,
        title: ASSESSMENT_TITLES[payload.assessmentType],
        view: VIEWS.SHOW,
        assessmentType: payload.assessmentType,
        cameFrom: state.view
      }
    case GO_TO_DELETE:
      return {
        ...state,
        view: VIEWS.DELETE,
        assessmentType: payload.assessmentType,
        cameFrom: state.view
      }
    case GO_TO_UPDATE_FORM:
      return {
        ...state,
        title: ASSESSMENT_TITLES[payload.assessmentType],
        view: VIEWS.UPDATE,
        cameFrom: state.view,
        formAction: FORM_ACTIONS.UPDATE,
        assessmentType: payload.assessmentType
      }
    case GO_BACK:
      return {
        ...state,
        view: state.cameFrom,
        cameFrom: state.view
      }
    case MARK_ASSET_FOR_ASSESSMENT:
      return {
        ...state,
        assets: payload.newAssets,
      }
    case MARK_LIABILITY_FOR_ASSESSMENT:
      return {
        ...state,
        liabilities: payload.newLiabilities,
      }
    case MARK_RISK_PRODUCT_FOR_ASSESSMENT:
      return {
        ...state,
        riskProducts: payload.newRiskProducts,
      }
    case SUBMIT_FORM:
      return {
        ...state,
        view: VIEWS.SHOW,
        cameFrom: VIEWS.INDEX,
        assessmentType: payload.assessmentType,
        loading: false
      }
    case DELETE_ASSESSMENT:
      return {
        ...state,
        view: VIEWS.INDEX,
        assessmentType: null,
        loading: false,
      }

    case LOADING:
      return {
        ...state,
        loading: true
      }
    default:
      return { ...state }
  }
}

export const propsToState = () => ({
  title: 'Financial needs analysis',
  view: VIEWS.INDEX,
  cameFrom: VIEWS.INDEX,
  assessmentType: null,
  loading: false,
})
